const PitchSvg = ({ className = "", rotate = true }) => {
  return (
    <svg
      className={`${className} ${rotate ? "tw-rotate-90" : ""}`}
      width="65%"
      viewBox="0 0 386 595"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={rotate ? { transform: 'rotate(90deg)', transformOrigin: '76.5% center' } : {}}
    >
      <rect x="1.5" y="1.5" width="383" height="591.894" rx="2.5" stroke="#9DDC18" strokeWidth="3"/>
      <path
        d="M78.2002 507.53C78.2002 503.664 81.3342 500.53 85.2002 500.53H300.8C304.666 500.53 307.8 503.664 307.8 507.53V593.894H78.2002V507.53Z"
        stroke="#C2C7D3"
        strokeWidth="2"
      />
      <path
        d="M138.371 566.565C138.371 562.699 141.505 559.565 145.371 559.565H238.359C242.225 559.565 245.359 562.699 245.359 566.565V593.894H138.371V566.565Z"
        stroke="#C2C7D3"
        strokeWidth="2"
      />
      <path
        d="M152.129 500.665C167.456 476.824 208.894 466.606 234.438 500.665"
        stroke="#C2C7D3"
        strokeWidth="2"
      />
      <circle
        cx="193"
        cy="297.447"
        r="51.2235"
        stroke="#C2C7D3"
        strokeWidth="2"
      />
      <line
        y1="296.447"
        x2="386"
        y2="296.447"
        stroke="#C2C7D3"
        strokeWidth="2"
      />
      <circle
        cx="193"
        cy="531.317"
        r="3.27059"
        stroke="#C2C7D3"
        strokeWidth="2"
      />
      <path
        d="M78.2002 87.365C78.2002 91.231 81.3342 94.365 85.2002 94.365H300.8C304.666 94.365 307.8 91.231 307.8 87.365V1.00028H78.2002V87.365Z"
        stroke="#C2C7D3"
        strokeWidth="2"
      />
      <path
        d="M138.371 28.3297C138.371 32.1957 141.505 35.3297 145.371 35.3297H238.359C242.225 35.3297 245.359 32.1957 245.359 28.3297V1.0003H138.371V28.3297Z"
        stroke="#C2C7D3"
        strokeWidth="2"
      />
      <path
        d="M152.129 94.2297C167.456 118.071 208.894 128.288 234.438 94.2297"
        stroke="#C2C7D3"
        strokeWidth="2"
      />
      <circle
        cx="2.27059"
        cy="2.27059"
        r="3.27059"
        transform="matrix(1 0 0 -1 190.729 65.8468)"
        stroke="#C2C7D3"
        strokeWidth="2"
      />
    </svg>
  );
};

export default PitchSvg;
